import TV from "../assets/images/new-tv.png";
import homeLogo from "../assets/images/mocaverse.svg";

function loadingTV() {
  return (
    <>
      <div class="tv__wrapper">
        <div class="tv__inner">
          <img src={TV} alt="TV" class="tvclick" />
          <img
            src={homeLogo}
            alt="Off To The Realm Logo"
            class="small-logo tv__small-logo"
          />
          <div class="tv__button">
            <button id="tvclick-btn" class="btn">
              Enter
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default loadingTV;
